import React from 'react';
import ProfilePage from './ProfilePage';

const Profile = (props) => {
    return <ProfilePage {...props} />;
};

export default Profile;
